{
  "unit": {
    "kwh": "kWh",
    "du": "kWh",
    "du_hint": ""
  },
  "fmt": {
    "less_than": "under {{v}}",
    "approx": "about {{v}}"
  },
  "cmp": {
    "flat": "Flat",
    "more_pct": "{{pct}}% more",
    "less_pct": "{{pct}}% less",
    "more_abs": "{{v}} more",
    "less_abs": "{{v}} less",
    "why_prev_coverage": "Previous period was only {{pct}}% complete (under 90%), so not compared",
    "why_meters_changed": "Measuring points changed since the previous period, so not compared",
    "why_prev_small": "Previous period under 1 kWh; showing the difference instead",
    "why_unavailable": "Unavailable, so not compared",
    "why_no_prev": "No data for the previous period, so not compared",
    "why_btn": "Why no comparison"
  },
  "q": {
    "measured": "Measured",
    "estimated": "Estimated",
    "incomplete": "No data"
  },
  "chart": {
    "numbers": "Show numbers",
    "group": "{{title}} (use arrow keys to move between bars)",
    "legend_bar": "Measured",
    "legend_est": "Estimated",
    "legend_miss": "No data (not zero)",
    "legend_live": "In progress",
    "legend_zero": "Measured zero",
    "col_time": "Time",
    "col_quality": "Data quality",
    "total": "Total",
    "prev_day": "Previous day",
    "next_day": "Next day",
    "prev_cell": "Previous",
    "next_cell": "Next",
    "say_day": "{{label}}, {{v}}, {{q}}",
    "say_live": "{{label}}, {{v}}, in progress (to {{time}})",
    "say_miss": "{{label}}, no data",
    "day_label": "{{m}}/{{d}}",
    "hour_label": "{{h}}:00",
    "month_label": "Month {{m}}",
    "tz_note": "Shown in {{tz}}; daily totals use each $t(translation:leaf.cur_lc)’s local date"
  },
  "meter": {
    "poe_powered": "{{station}} · powered by port {{port}}",
    "port": "{{station}} port {{port}}",
    "port_of_home": "{{home}} {{station}} port {{port}}",
    "unmatched": "No matching device"
  },
  "kind": {
    "plug": "Plug",
    "poe": "PoE power",
    "meter": "Meter"
  },
  "title": "Energy",
  "subtitle": "How much electricity your reporting devices used, and roughly what it cost",
  "tab": {
    "overview": "Overview",
    "ranking": "Ranking",
    "report": "Reports"
  },
  "settings_btn": "Energy settings",
  "settings_pick": "Choose a $t(translation:leaf.cur_lc) to set up",
  "no_access_page": "Only people who can view energy data can open this page",
  "empty": "{{scope}} has no devices that report energy. Devices that do: {{brand}} plugs, Kinio Stations with per-port PoE power, and Matter plugs / meters connected through a {{brand}} hub.",
  "empty_all": "Switch to All",
  "load_err": "Couldn’t load energy data ({{reason}})",
  "retry": "Retry",
  "partial_err": "Some organizations’ energy data couldn’t be loaded; totals below include only what loaded",
  "mock_banner": "Sample data: the energy API isn’t on this environment yet",
  "first_notice": "First time here: energy data is shown only to people allowed to view it. It covers plugs, PoE power and meters, not the whole $t(translation:leaf.cur_lc)’s consumption.",
  "dismiss": "Got it",
  "period": {
    "month_to_date": "Month to date",
    "last_month": "Last month",
    "today": "Today",
    "week": "Week to date",
    "year": "Year to date"
  },
  "need": {
    "title": "Needs attention",
    "count": "{{n}}",
    "count_shown": "{{n}} · showing {{shown}}",
    "show_all": "Show all {{n}}",
    "plug_title": "{{home}} · {{name}} turned off due to overload",
    "plug_rated": "At {{time}} it drew {{w}}, over the plug’s limit of {{limit}} · now 0 W",
    "plug_user": "At {{time}} it drew {{w}}, over the set limit of {{limit}} · now 0 W",
    "poe_title_high": "{{home}} · {{name}} PoE power is over the high threshold ({{pct}}%)",
    "poe_title_warn": "{{home}} · {{name}} PoE power is over the warning threshold ({{pct}}%)",
    "poe_detail": "Allocated {{alloc}} / {{rated}} ({{pct}}%) · actual {{used}}",
    "poe_more_cam": "A new camera may not get power",
    "poe_incident": "IT monitoring is on for this $t(translation:leaf.cur_lc); an incident is open",
    "home_unavailable": "{{home}} unavailable for {{h}} h (since {{since}})",
    "home_unavailable_d": "Station and plugs are offline; this period isn’t counted",
    "gap_title": "{{n}} measuring points have had no data for over {{h}} h",
    "gap_detail": "{{list}}; devices are online but not reporting energy",
    "gap_item": "{{home}}: {{n}}",
    "act_device": "View device",
    "act_incident": "View incident",
    "act_poe": "View power",
    "act_home": "View $t(translation:leaf.cur_lc)",
    "act_which": "See which"
  },
  "card": {
    "energy": "Energy, month to date",
    "energy_period": "Energy, {{period}}",
    "cmp_prev_month": "vs. same period last month",
    "cmp_prev": "vs. same period last time",
    "cmp_basis": "Comparing the same {{homes}} $t(translation:leaf.cur_lc_pl) and {{meters}} measuring points",
    "cmp_excluded": "Not compared: {{list}}",
    "cmp_ex_new": "{{home}} (new measuring points)",
    "cmp_ex_cov": "{{home}} (previous period under 90% complete)",
    "cmp_ex_other": "{{home}}",
    "cmp_none": "Not compared: {{why}}",
    "incomplete": "{{meters}} measuring points incomplete ({{hours}} h missing)",
    "forecast": "Full-month estimate {{v}}",
    "cost": "Est. cost",
    "cost_homes": "{{n}} $t(translation:leaf.cur_lc_pl)",
    "cost_more": "{{n}} currencies",
    "cost_note": "Each currency listed separately, no conversion · excludes fixed charges",
    "cost_disclaimer": "Estimates only; not for billing or cost allocation",
    "no_tariff": "{{n}} $t(translation:leaf.cur_lc_pl) have no tariff and aren’t included",
    "no_tariff_any": "No tariff set yet",
    "set_tariff": "Set tariff",
    "carbon": "Emissions",
    "carbon_note": "{{region}}: {{provisional}}{{year}} {{source}} factor",
    "carbon_provisional": "provisional ",
    "carbon_co2only": " (CO2 only)",
    "carbon_ref": "For operational reference only",
    "poe_note": "PoE power excludes the Station itself and power-conversion losses.",
    "visible_only": "Includes only the {{visible}} $t(translation:leaf.cur_lc_pl) whose energy you can view ({{total}} in scope)",
    "unavailable_homes": "{{n}} $t(translation:leaf.cur_lc_pl) unavailable and not included"
  },
  "trend": {
    "title_day": "Trend · hourly today",
    "title_month": "Trend · daily",
    "title_year": "Trend · monthly",
    "day": "Day",
    "month": "Month",
    "year": "Year",
    "granularity": "Trend period",
    "by_kind": "By type",
    "total_only": "Total",
    "compare": "Compare $t(translation:leaf.cur_lc_pl)…",
    "compare_n": "Compare $t(translation:leaf.cur_lc_pl) ({{n}})",
    "compare_title": "Choose up to 5 $t(translation:leaf.cur_lc_pl) to compare",
    "compare_done": "Compare",
    "compare_clear": "Stop comparing",
    "compare_max": "Up to 5",
    "daily_total": "Daily total",
    "today_live": "Today (in progress, to {{time}})"
  },
  "table": {
    "by_home": "By $t(translation:leaf.cur_lc)",
    "by_org": "By organization",
    "sort_hint": "Sorted by change vs. last month; rows that can’t be compared show “—” (select it for the reason) and come last.",
    "sort_cmp": "vs. last month",
    "sort_energy": "Energy",
    "col_home": "$t(translation:leaf.cur)",
    "col_org": "Organization",
    "col_kwh": "This month (kWh)",
    "col_period_kwh": "This period (kWh)",
    "col_cmp": "vs. last month",
    "col_cmp_period": "vs. last period",
    "col_daily": "Daily avg.",
    "col_cost": "Est. cost",
    "col_meters": "Points",
    "col_unavail": "Unavailable (points)",
    "col_carbon": "Emissions",
    "no_tariff": "No tariff",
    "more": "{{n}} more $t(translation:leaf.cur_lc_pl)",
    "show_all": "Show all {{n}}",
    "cross_currency": "Not sorted across currencies",
    "homes_count": "{{n}} $t(translation:leaf.cur_lc_pl)",
    "m2": "vs. last month {{cmp}} · {{cost}} · {{n}} points unavailable",
    "m2_ok": "vs. last month {{cmp}} · {{cost}}",
    "unavailable": "Unavailable"
  },
  "ups": {
    "title": "UPS",
    "line_ok": "{{n}} UPS · all on mains",
    "line_battery": "{{n}} UPS · {{b}} on battery · shortest runtime {{rt}}",
    "line_battery_unk": "{{n}} UPS · {{b}} on battery · runtime unavailable",
    "unreadable": "{{n}} unavailable",
    "minutes": "{{n}} min",
    "note": "UPS output measures a different set of equipment and isn’t added to the totals above.",
    "go": "Open in IT monitoring",
    "load_err": "Couldn’t load UPS status"
  },
  "rank": {
    "by_device": "By device",
    "by_port": "By PoE port",
    "group": "Group by",
    "kinds": "Type",
    "all_homes": "All $t(translation:leaf.cur_lc_pl)",
    "search": "Find a device or $t(translation:leaf.cur_lc)",
    "export": "Export CSV",
    "col_name": "Name",
    "col_kind": "Type",
    "col_kwh": "This period (kWh)",
    "col_avg": "Avg. power",
    "col_max": "Max power",
    "col_cost": "Est. cost",
    "col_cmp": "vs. last period",
    "col_mode": "Power mode",
    "col_pick": "Select",
    "pick_all": "Select all cameras on this page that can be changed",
    "pick_row": "Select {{name}}",
    "no_control": "You don’t have control permission for this camera, so you can’t change its power mode",
    "mode_changed": "Changed to “{{mode}}” on {{date}}",
    "mode_effect": "Changed to “{{mode}}” on {{date}} · {{days}} days before vs. after: {{cmp}}",
    "footer": "{{from}}–{{to}} of {{total}} measuring points",
    "footer_filtered": "Filter “{{f}}” · {{from}}–{{to}} of {{total}} measuring points",
    "next": "Next page",
    "prev": "Previous page",
    "empty": "No energy data for this period",
    "filters": "Sort & filter",
    "close": "Close",
    "show": "Show {{n}}",
    "sort": "Sort",
    "sort_kwh": "Most energy first",
    "sort_avg": "Highest avg. power first",
    "sort_max": "Highest max power first",
    "sort_cmp": "Biggest increase first",
    "by_station": "{{home}} · {{station}}",
    "csv_name": "energy-ranking"
  },
  "pm": {
    "0": "Quality first",
    "1": "Balanced",
    "2": "Power saving first",
    "picked": "{{n}} cameras selected",
    "why": "This saves on electricity cost; PoE allocation is reserved by class, so changing the power mode won’t lower it. Permission is checked per camera.",
    "clear": "Clear selection",
    "set": "Set power mode…",
    "dlg_title": "Change {{n}} cameras to…",
    "dlg_saving": "Saves on cost: based on the last 7 days, about {{v}} less per month",
    "dlg_alloc": "Changing the power mode won’t lower PoE allocation; to free budget, use lower-class cameras or move some to another Station.",
    "dlg_affects": "Affects: {{names}}",
    "dlg_quality": "“Power saving first” may reduce night lighting and image quality.",
    "dlg_ok": "Apply to {{n}}",
    "dlg_cancel": "Cancel",
    "result_title": "Power mode results",
    "result_summary": "{{applied}} applied, {{pending}} waiting for the device",
    "result_failed": "{{n}} not applied",
    "st_applied": "✓ Applied",
    "st_pending": "⟳ Waiting for device",
    "st_failed": "✕ Not applied by device",
    "st_forbidden": "✕ No control permission",
    "deadline": "Result by {{time}} at the latest; if not applied by then it shows “Not applied by device”",
    "retry": "Retry",
    "done": "Done",
    "err": "Couldn’t set: {{msg}}"
  },
  "report": {
    "month": "Month",
    "month_opt": "{{y}}-{{m}}",
    "opt_provisional": " (provisional)",
    "opt_final": " (final)",
    "provisional": "Provisional: late device reports may still change these numbers; final on {{date}}",
    "final": "Final",
    "date_md": "{{m}}/{{d}}",
    "scope_total": "Scope total",
    "gaps": "{{hours}} h missing ({{meters}} measuring points)",
    "no_gaps": "No gaps",
    "summary_by": "Summary by $t(translation:leaf.cur_lc)",
    "only_gaps": "Only with gaps ({{n}})",
    "has_gap": "! Gaps",
    "expand": "Show measuring points for {{home}}",
    "top": "Top 10",
    "rounding": "Rows are rounded; totals use unrounded values (CSV keeps two decimals)",
    "csv_homes": "Download CSV (per $t(translation:leaf.cur_lc) × day)",
    "csv_meters": "Download CSV (per measuring point × month)",
    "csv_prefix": "energy",
    "provisional_tag": "provisional",
    "carbon_basis": "{{gas}} · {{year}} factor",
    "pdf_later": "PDF and monthly email coming later"
  },
  "csv": {
    "disclaimer": "Estimates only; not for billing or cost allocation",
    "date": "Date",
    "month": "Month",
    "home": "$t(translation:leaf.cur)",
    "org": "Organization",
    "meter_name": "Measuring point",
    "meter_kind": "Type",
    "kwh": "Energy (kWh)",
    "avg_w": "Avg. power (W)",
    "max_w": "Max power (W)",
    "cost": "Est. cost ({{cur}})",
    "currency": "Currency",
    "cost_amount": "Est. cost",
    "quality": "Data quality (measured / estimated / no data)",
    "missing_h": "Missing hours",
    "carbon": "Emissions (kg)",
    "carbon_basis": "Emissions basis"
  },
  "org": {
    "card_title": "Tariffs & emissions",
    "card_hint": "{{n}} tariffs · applied to $t(translation:leaf.cur_lc_pl) to estimate cost",
    "manage": "Manage tariffs",
    "title": "Tariffs",
    "crumb": "Organization settings",
    "hint": "Tariffs applied to $t(translation:leaf.cur_lc_pl) let the Energy page estimate cost. Tip: put $t(translation:leaf.cur_lc_pl) on the same rates under one plan with [Apply to $t(translation:leaf.cur_lc_pl)…] and maintain just that; use [New version…] only to keep the name and version history.",
    "no_admin": "Only the organization owner or admins can manage tariffs",
    "col_name": "Plan",
    "col_kind": "Type",
    "col_currency": "Currency",
    "col_applied": "Applied to",
    "col_version": "Current version",
    "applied_n": "{{n}} $t(translation:leaf.cur_lc_pl)",
    "version_from": "v{{v}} · from {{date}}",
    "kind_flat": "Flat rate",
    "kind_tiered": "Tiered",
    "kind_tou": "Time of use",
    "add": "Add plan",
    "apply": "Apply to $t(translation:leaf.cur_lc_pl)…",
    "new_version": "New version…",
    "delete": "Delete",
    "delete_confirm": "Delete “{{name}}”?",
    "in_use": "{{n}} $t(translation:leaf.cur_lc_pl) still use this plan; move them to another plan first",
    "empty": "No tariffs yet",
    "carbon_title": "Emissions",
    "show_carbon": "Show the emissions card on the Energy overview",
    "carbon_category": "Emission factor category",
    "cat_grid": "Grid average (by region and year)",
    "saved": "✓ Saved",
    "recalc": "Recalculating, about 1 minute",
    "no_rates": "Unit prices hidden (visible to owners/admins only)"
  },
  "ed": {
    "title": "New tariff",
    "from_template": "From a template",
    "custom": "Custom",
    "template": "Template",
    "template_note": "Template prices follow official notices and are a starting point you can edit.",
    "name": "Plan name",
    "kind": "Type",
    "currency": "Currency",
    "effective": "Effective from",
    "effective_hint": "Defaults to the 1st of this month; up to 30 days back; finalized months aren’t recalculated",
    "flat_price": "Price per kWh",
    "tier": "Tier {{n}}",
    "tier_upto": "Up to {{v}} kWh/month",
    "tier_rest": "Above that",
    "tou_period": "{{name}} ({{days}} {{from}}:00–{{to}}:00)",
    "days_weekday": "Mon–Fri",
    "days_weekend": "Weekends & holidays",
    "days_all": "Every day",
    "per_kwh": "{{cur}} / kWh",
    "save": "Create plan",
    "cancel": "Cancel",
    "err_name": "Plan name is required",
    "err_price": "Price must be 0 or more",
    "version_title": "New version of “{{name}}”",
    "version_save": "Add version"
  },
  "apply": {
    "title": "Apply “{{name}}” to $t(translation:leaf.cur_lc_pl)",
    "filter_old": "On an older plan ({{n}})",
    "filter_none": "No tariff ({{n}})",
    "filter_all": "All ({{n}})",
    "shown": "Showing {{n}} $t(translation:leaf.cur_lc_pl)",
    "hidden": "{{n}} others don’t match",
    "clear_filter": "Clear filter",
    "current": "Now: {{name}}",
    "current_none": "Now: no tariff",
    "already": "Already on this plan",
    "currency_diff": "Different currency ({{cur}}); can’t apply",
    "pick_all": "Select all in “{{group}}”",
    "next": "Apply to {{n}} $t(translation:leaf.cur_lc_pl)…",
    "confirm_title": "Apply “{{name}}” to {{n}} $t(translation:leaf.cur_lc_pl)",
    "confirm_body": "Estimated cost for these {{n}} $t(translation:leaf.cur_lc_pl) from {{date}} will be recalculated; reports already downloaded won’t change.",
    "confirm_old": "{{n}} of them were on “{{old}}”.",
    "final_warn": "{{month}} is final and won’t be recalculated",
    "ok": "Apply",
    "done": "Applied to {{n}} $t(translation:leaf.cur_lc_pl)",
    "done_one": "Applied",
    "undo": "Undo",
    "none_picked": "Select $t(translation:leaf.cur_lc_pl) first"
  },
  "leaf": {
    "title": "Energy settings",
    "crumb_sites": "Organization & sites",
    "locked": "Only owners or admins can change this",
    "tariff": "Tariff",
    "tariff_org": "Using: {{name}}",
    "tariff_home": "{{name}} (set for this $t(translation:leaf.cur_lc))",
    "tariff_none": "No tariff set",
    "tariff_pick": "Change",
    "tariff_none_opt": "No tariff (cost not counted)",
    "tariff_custom": "Custom… (Organization settings › Tariffs)",
    "alerts": "Energy alerts",
    "poe": "PoE power",
    "poe_desc": "Alert when allocation exceeds this share of the Station’s rated power",
    "poe_warn": "Warning",
    "poe_high": "High",
    "pct": "%",
    "gap": "No data",
    "gap_desc": "Alert when an online device hasn’t reported energy for this many hours",
    "hours": "hours",
    "kmgr_on": "IT monitoring is on for this $t(translation:leaf.cur_lc): crossing a threshold opens an incident and notifies the on-call rota",
    "kmgr_off": "Crossing a threshold notifies this $t(translation:leaf.cur_lc)’s owners and admins (inbox only)",
    "managed": "Managed by template “{{name}}”",
    "unmanage": "Stop template management",
    "unmanage_confirm": "After this you can edit the thresholds here; later template changes won’t apply to this $t(translation:leaf.cur_lc).",
    "saved": "✓ Saved",
    "saving": "Saving…",
    "err_range": "Must be a whole number from {{min}} to {{max}}",
    "err_order": "Warning can’t be higher than High",
    "pick_title": "Choose a $t(translation:leaf.cur_lc)",
    "not_found": "This $t(translation:leaf.cur_lc) doesn’t exist or you don’t have access",
    "to_overview": "View this $t(translation:leaf.cur_lc)’s energy"
  },
  "dev": {
    "title": "Energy",
    "now": "Now",
    "today": "Today",
    "month": "Month to date",
    "cost": "Est. cost",
    "via_poe": "Measured from PoE power ({{station}} port {{port}})",
    "range_day": "Day",
    "range_week": "Week",
    "range_month": "Month",
    "chart_day": "Hourly energy, last 24 hours",
    "chart_week": "Daily energy, last 7 days",
    "chart_month": "Daily energy, last 30 days",
    "export": "Export CSV",
    "no_data": "No energy data yet",
    "load_err": "Couldn’t load energy data",
    "mode_mark": "Changed to “{{mode}}” {{date}}"
  },
  "stn": {
    "budget": "PoE power: allocated {{alloc}} / {{rated}} · actual {{used}}",
    "budget_norated": "PoE power: currently {{used}}",
    "alloc_note": "Allocation is {{diff}} above actual use: PoE reserves power by class; changing a camera’s power mode saves cost but doesn’t lower allocation.",
    "col_today": "Today",
    "col_24h": "24 hours",
    "today": "Today {{v}}",
    "spark": "Port {{port}} power, last 24 hours",
    "expand": "Show 7-day curve for port {{port}}",
    "collapse": "Hide",
    "week_title": "Port {{port}} · hourly PoE power, last 7 days",
    "no_detail": "This Station doesn’t report per-port PoE power",
    "load_err": "Couldn’t load power data",
    "unknown": "Unknown",
    "budget_noalloc": "PoE power: rated {{rated}} · actual {{used}}",
    "col_energy": "Energy"
  },
  "syn": {
    "energy": "energy,electricity,cost,tariff,power,kWh,emissions,carbon,PoE",
    "org_tariffs": "tariff,rate,price,emission factor",
    "leaf_settings": "energy settings,energy alerts,PoE threshold,tariff",
    "ups": "UPS,power outage,battery,PoE"
  },
  "search": {
    "leaf_settings": "Energy settings for a $t(translation:leaf.cur_lc) (choose one first)",
    "ups": "Network & apps · UPS"
  },
  "err": {
    "ENERGY_RANGE_TOO_LARGE": "The period is too long; choose a shorter one",
    "ENERGY_TARIFF_INVALID": "Invalid tariff: {{reason}}",
    "ENERGY_TARIFF_IN_USE": "Some $t(translation:leaf.cur_lc_pl) still use this plan",
    "FORBIDDEN": "You don’t have permission",
    "VERSION_CONFLICT": "Someone just changed this; reload and try again",
    "NOT_FOUND": "The energy service doesn’t have this yet",
    "other": "Something went wrong ({{code}})",
    "copy": "Copy for support",
    "details": "Details"
  },
  "loading": "Loading…"
}
